interface Props {
  fill?: string,
  width?: string | number,
}

const Avatar = ({
  fill = '#000',
  width = '14mm',
}: Props) => (
  <svg
    id="svg2002"
    version="1.1"
    viewBox="0 0 14.54609 18.938169"
    width={width}
  >
    <defs
      id="defs1996"
    />
    <g
      transform="translate(-102.34005,-108.45948)"
      id="layer1"
    >
      <path
        d="m 113.62542,118.70733 c -0.97967,1.00824 -2.43382,1.59491 -4.0132,1.59491 -1.57904,0 -3.03283,-0.58667 -4.0125,-1.59491 -1.71908,1.35396 -2.7305,3.46745 -2.7305,5.76156 0.002,0 0.28822,2.3996 6.743,2.3996 6.46853,0 6.74299,-2.40877 6.74476,-2.43417 -7.2e-4,-2.26201 -1.01248,-4.37303 -2.73156,-5.72699 z m -4.0132,-0.74966 c 2.23837,0 4.04036,-2.73191 4.04036,-4.99392 0,-2.19216 -1.81292,-3.9751 -4.04036,-3.9751 -2.22674,0 -4.0386,1.78294 -4.0386,3.9751 0,2.26201 1.80163,4.99392 4.0386,4.99392 z"
        fill={fill}
        id="path872"
      />
    </g>
  </svg>
);

export default Avatar;
